var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Wrapper',[_c('Tabs',[_c('Tab',{attrs:{"title":"Alterar Endereço"}},[_c('AlterAddress')],1),_c('Tab',{attrs:{"title":"Alterar Senha"}},[_c('AlterPassword')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }